import React from "react";
import { Link } from "react-router-dom";
import renderPlainTextDescription from "../helpers/helper";

const AllJobs = (props) => {
    
    return (
        <div className="col-auto wow fadeInUp shadow-lg p-3 bg-white rounded m-2 p-2 d-flex flex-column mx-md-3 mx-auto" data-wow-delay="0.5s">
            
            <div className="causes-item d-flex flex-column bg-white rounded-top overflow-hidden h-30 ">
                <div className="position-relative mt-auto post-container ">
                    {props.item.feature_img?.src ? (
                        <img className="img-fluid" src={props.item.feature_img.src} alt="" style={{objectFit:'cover',maxWidth:'374px'}}
                        onError={(e) => {
                            e.target.src = '/assets/images/jobTemp.jpg';
                            }}
                        />
                    ): (
                        <img className="img-fluid" src='/assets/images/jobTemp.jpg' alt="" style={{objectFit:'cover',maxWidth:'374px'}}
                        onError={(e) => {
                            e.target.src = '/assets/images/jobTemp.jpg';
                            }}
                        />
                    )}
                </div>
            </div>

            <div className="w-250 container text-start pt-3 m-h-100 d-flex flex-column flex-grow-1">
                <h4>{props.item.title}</h4>
                <p className='plain-text'>
                    {renderPlainTextDescription(props.item.description, 20)}
                </p>
                
                <Link className="btn btn-outline-warning w-100 mt-auto"
                    to={`/job-vacancy/${props.item.id}`}>
                    Explore Job Detail
                </Link>
            </div>
        </div>
    );
}

export default AllJobs;